'use client';
/* Built In Imports */

/* External Imports */
import {
  ArticleIcon,
  SpeakerIcon,
  VideoIcon,
} from '@app-ps/Components/Icon/wisdomCardIcon';
import { Box, Skeleton, Text } from '@chakra-ui/react';
import { css } from '@emotion/react';
/* Internal Imports */
/* Components */
import StructuredTextContent from '@app-ps/Common/StructuredTextContent';
import ArticleBanner from '@app-ps/Components/Banners/ArticleBanner';
import RelatedPost from '@app-ps/Components/RelatedPost';
import SubscribeContent from '@app-ps/Components/Ui/SubscribeContent';
/* Services */
import EmbedIcons from '@app-ps/Components/Icon/EmbedIcons';
import { Suspense } from 'react';

/* Styles */

const BlogUi = ({ pageData, region, lang }) => {
  const signatureStyle = css`
    .css-t54dvu {
      @media (min-width: 48em) and (max-width: 62em) {
        /* Medium devices and up */
        margin-left: 2rem;
      }
    }
    .css-pzgetq {
      @media (min-width: 48em) and (max-width: 62em) {
        /* Medium devices and up */
        padding-left: 2rem;
      }
    }
    .css-fyf57n {
      @media (min-width: 48em) and (max-width: 62em) {
        /* Medium devices and up */
        padding-left: 2rem;
      }
    }
    .css-vqgvzs {
      /* Medium devices and up */
      line-height: 35.2px;
    }

    .css-1tdndko {
      @media (min-width: 48em) and (max-width: 62em) {
        /* Medium devices and up */
        line-height: 35.2px;
        padding-inline: 2rem;
      }
    }
  `;

  const newsLetterJson = {
    _modelApiKey: 'newsletter_subscription_form',
    newsletterIdentifier: 'projectsamskriti',
    content: {
      json: {
        title: 'Stay Connected',
        title1: 'with ',
        title2: 'Project Samskriti',
        description:
          "Subscribe to our newsletter for updates on Project Samskriti's productions, workshops, insightful blogs and impactful initiatives.",
        name: 'Full Name',
        email: 'Email ID',
        country: 'Country',
        submitButton: 'SUBSCRIBE',
      },
      _modelApiKey: 'generic_reusable_json',
    },
  };
  const isBodyContentEmpty = pageData?.body?.value?.document?.children?.every(
    child =>
      child?.children?.every(span => !span?.value || span?.value.trim() === '')
  );
  const date = new Date(pageData?.createdAt);
  const isAudioVideo =
    pageData?.types === 'audio' || pageData?.types === 'video';
  const iconToShow = {
    article: (
      <ArticleIcon
        pt="0"
        width={{ base: '12px', md: '20px' }}
        height={{ base: '12px', md: '20px' }}
        viewBox={{ base: '0 0 23px 23px', md: '0 0 36px 36px' }}
        color={isAudioVideo && '#F1EDE9'}
      />
    ),
    audio: (
      <SpeakerIcon
        pt="0"
        width={{ base: '23px', md: '24px' }}
        height={{ base: '23px', md: '24px' }}
        viewBox={{ base: '0 0 23px 23px', md: '0 0 24px 24px' }}
        color={'#F1EDE9'}
      />
    ),
    video: (
      <VideoIcon
        pt="0"
        width={{ base: '23px', md: '36px' }}
        height={{ base: '23px', md: '36px' }}
        viewBox={{ base: '0 0 23px 23px', md: '0 0 36px 36px' }}
        color={'#F1EDE9'}
      />
    ),
  };
  return (
    <Suspense fallback={<Skeleton />}>
      <Box
        as="section"
        className="container-article"
        p="0"
        mb={{ base: '-2rem' }}
      >
        <ArticleBanner pageData={pageData} />
        <Box
          pt={{ base: '8px', md: isAudioVideo ? '0' : '30px' }}
          fontSize="16px"
          maxW="970px"
          pb={{ base: '15px', md: '30px' }}
          mx="auto"
          width="100%"
          bgColor={isAudioVideo ? '' : '#F1EDE9'}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            color={isAudioVideo ? '#F1EDE9' : '#0E1216'}
            mt="0"
            mb={{ base: '15px', md: '30px' }}
            fontFamily={'var(--FedraSansStd-book)'}
          >
            {iconToShow[pageData?.types]}
            <Text as="span" ml="8px">
              {`${date.getDate()} ${date.toLocaleString('default', {
                month: 'short',
              })} ${date.getFullYear()}`}
            </Text>
          </Box>

          <Box
            maxW="720px"
            fontSize={{ base: '1rem', md: '1.125rem' }}
            px={{ base: '1rem', md: '0' }}
            m="0 auto"
            css={signatureStyle}
          >
            <EmbedIcons
              iconColor={isAudioVideo ? '#F1EDE9' : '#44403B'}
              gap="1.8rem"
              iconSize={{ base: 20, md: '32' }}
            />

            {StructuredTextContent(
              pageData?.body,
              region,
              lang,
              'blog',
              pageData
            )}

            {!isBodyContentEmpty && (
              <EmbedIcons
                iconColor={isAudioVideo ? '#F1EDE9' : '#44403B'}
                gap="2rem"
              />
            )}
          </Box>
        </Box>
        {pageData?.relatedPosts?.length > 0 && (
          <Box>
            <RelatedPost
              pageData={pageData?.relatedPosts}
              titleText1={pageData?.titleText1}
              titleText2={pageData?.titleText2}
              region={region}
              lang={lang}
              pt={isAudioVideo ? '0' : '100px'}
              pb="0"
            />
          </Box>
        )}

        <SubscribeContent
          sectionContent={newsLetterJson}
          lang={lang}
          region={region}
          mb={{ base: '70px', md: '100px' }}
          isBlog
        />
        {/* <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
  /> */}
      </Box>
    </Suspense>
  );
};

export default BlogUi;
